import { h } from 'preact';
import { useState, useEffect } from 'preact/hooks';
import ShowByDomain from './showByDomain.js';

function Search ({ searchBasePath, siteTld, searchStr }) {
  return <ShowByDomain searchStr={searchStr}/>
}

export default Search

